/**
 * Estimator — route configuration.
 * Sales tool for estimate workflow + proposal generation.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { HealthPage } from './pages/HealthPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { DashboardPage } from './pages/DashboardPage';
import { NewEstimatePage } from './pages/NewEstimatePage';
import { EstimateDetailPage } from './pages/EstimateDetailPage';
import { ProposalsPage } from './pages/ProposalsPage';
import { MailboxPage } from './pages/MailboxPage';
import { SettingsPage } from './pages/SettingsPage';
import { CrmEntryPage } from './pages/CrmEntryPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/health" element={<HealthPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="crm/account/:zohoAccountId" element={<CrmEntryPage />} />
          <Route path="estimates/new" element={<NewEstimatePage />} />
          <Route path="estimates/:id/edit" element={<NewEstimatePage mode="edit" />} />
          <Route path="estimates/:id" element={<EstimateDetailPage />} />
          <Route path="proposals" element={<ProposalsPage />} />
          <Route path="mailbox" element={<MailboxPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
